import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['Authorization'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + store.getters.token;
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列
let requests = []

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return response
    }
    const res = response.data;
    // if the custom status is not 0, it is judged as an error.
    if (res.status === 1401) {
      store.dispatch('app/setCurrentAccountSet', {
        code: '',
        version: Date.now()
      }, { root: true });
      return res;
    } else if (res.status !== 0 && res.status !== 'success') {
      Message({
        message: res.message || res.messages || 'Error',
        type: 'error',
        duration: 5 * 1000
      });
      const error = new Error(res.message || res.messages || 'Error');
      error.response = res;
      return Promise.reject(error);
    } else {
      return res;
    }
  },
  async error => {
    const { config, response } = error
    if (config.url.includes('/userapi/user/token/refresh')) {
      return Promise.reject(error);
    }
    if (response.status === 401) {
      if (config._retry) {
        return Promise.reject(error);
      }
      if (process.env.VUE_APP_BASE_API) {
        config.url = config.url.replace(process.env.VUE_APP_BASE_API, '');
      }
      if (isRefreshing) {
        // 如果正在刷新，将请求存入队列
        return new Promise(resolve => {
          requests.push(() => {
            resolve(service(config))
          })
        })
      }
      config._retry = true
      isRefreshing = true
      try {
        // 调用刷新 token 的接口
        await store.dispatch('user/refreshToken');
        // 重试队列中的请求
        requests.forEach(cb => cb())
        requests = []
        // 重试原请求
        return service(config)
      } catch (err) {
        // 刷新 token 失败，跳转到登录页
        await store.dispatch('user/logout');
        return Promise.reject(err)
      } finally {
        isRefreshing = false
      }
    } else if (error.message.indexOf('timeout') >= 0) {
      Message({
        message: `服务器繁忙请稍后再试`,
        type: 'error',
        duration: 5 * 1000
      });
    } else {
      Message({
        message: `服务器繁忙请稍后再试`,
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default service;
